module.exports = __webpack_public_path__ + "img/6511.7245f947.jpg";